import qs from 'qs';
import { axiosApi } from '../axios';

const CLIENTS_BASE_URL = 'clients';
const ACCOUNTS_URL = 'accounts';
const PROJECTS_URL = 'projects';
const RECRUITMENTS_URL = 'recruitments';
const CANDIDATES_URL = 'candidates';
const ISSUES_URL = 'issues';
const DEVELOPERS_URL = 'developers';
const ATTACHMENTS_URL = 'attachments';

export default {
  accounts: {
    create(userData) {
      return axiosApi.post(`/${CLIENTS_BASE_URL}/${ACCOUNTS_URL}`, userData);
    },

    show() {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${ACCOUNTS_URL}`);
    },

    update(userData) {
      return axiosApi.patch(`/${CLIENTS_BASE_URL}/${ACCOUNTS_URL}`, userData);
    },

    delete() {
      return axiosApi.delete(`/${CLIENTS_BASE_URL}/${ACCOUNTS_URL}`);
    },
  },

  projects: {
    index(paginationParams) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}`, {
        params: paginationParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    show(id) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}/${id}`);
    },

    create(data) {
      return axiosApi.post(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}`, data);
    },

    update(id, projectData) {
      return axiosApi.patch(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}/${id}`, projectData);
    },

    delete(id) {
      return axiosApi.delete(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}/${id}`);
    },

    recentSummary(projectId) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}/${projectId}/reports/recent_summary`);
    },

    getReport(projectId, date) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}/${projectId}/reports/`, { params: date });
    },
  },

  recruitments: {
    show(id) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${RECRUITMENTS_URL}/${id}`);
    },

    create(projectId, data) {
      return axiosApi.post(`/${CLIENTS_BASE_URL}/${PROJECTS_URL}/${projectId}/${RECRUITMENTS_URL}`, data);
    },

    update(id, projectData) {
      return axiosApi.patch(`/${CLIENTS_BASE_URL}/${RECRUITMENTS_URL}/${id}`, projectData);
    },

    delete(id) {
      return axiosApi.delete(`/${CLIENTS_BASE_URL}/${RECRUITMENTS_URL}/${id}`);
    },
  },

  candidates: {
    updateStatus(id, status) {
      return axiosApi.patch(`/${CLIENTS_BASE_URL}/${CANDIDATES_URL}/${id}`, { status });
    },
  },

  issues: {
    index(paginationParams) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${ISSUES_URL}`, {
        params: paginationParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    show(id) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${ISSUES_URL}/${id}`);
    },

    create(data) {
      return axiosApi.post(`/${CLIENTS_BASE_URL}/${ISSUES_URL}/`, data);
    },

    reply(id, message) {
      return axiosApi.post(`/${CLIENTS_BASE_URL}/${ISSUES_URL}/${id}/issue_messages`, { content: message });
    },
  },

  developers: {
    show(id) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${DEVELOPERS_URL}/${id}`);
    },

    cv(developerId) {
      return axiosApi.get(`/${CLIENTS_BASE_URL}/${DEVELOPERS_URL}/${developerId}/cv`, { responseType: 'blob' });
    },
  },

  attachments: {
    create(formData) {
      return axiosApi.post(`/${CLIENTS_BASE_URL}/${ATTACHMENTS_URL}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },

    delete(attachmentId) {
      return axiosApi.delete(`/${CLIENTS_BASE_URL}/${ATTACHMENTS_URL}/${attachmentId}`);
    },
  },
};
